import { reactive, toRefs } from 'vue'
const state = reactive({
  appMenuCounter: 1
})

export function useAppMenu () {
  return {
    ...toRefs(state)
  }
}
